export interface ClientDestinationDetails {
  title: string;
  destinationTypeLabel: string;
  notificationId: string;
  blockchain: string;
  destinationPublicKey: string;
  verifiedLabel: string;
  destinationType: DestinationType;
  state: string;
  companyName: string;
}

export enum DestinationType {
  WITHDRAWAL = 'WITHDRAWAL',
  NEWOWNER_PUBLICKEY = 'NEWOWNER_PUBLICKEY',
  TRANSACTION_SENDER = 'TRANSACTION_SENDER'
}
